import { t } from 'i18next';
import { isCnpj, isFilled } from 'utils/old-ui-commons/validations';

export const CNPJ_MASK = [
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
];

const validatorForm = (values) => {
  const errors = {};

  if (isFilled(values.cnpj ?? '') && !isCnpj(values.cnpj ?? '')) {
    errors.cnpj = [t`type a valid cnpj`];
  }

  if (!isFilled(values.company_name ?? '')) {
    errors.company_name = [t`type a valid company name`];
  }

  if (isFilled(values.ie)) {
    if (values.ie.length > 14 || values.ie.length < 8) {
      errors.ie = [t`must be between 8 and 14 characters`];
    }
  }

  if (!isFilled(values.brand ?? '')) {
    errors.brand = [t`type a valid brand name`];
  }

  if (!values?.crt ?? '') {
    errors.crt = [t`select a valid tax regime`];
  }

  return errors;
};

export default validatorForm;
